export default "__VITE_ASSET__3301f821__"